/**
 * Converts any string into a safe HTML id.
 * - Normalizes Unicode (e.g. umlauts)
 * - replaces spaces with '-'
 * - removes disallowed characters
 * - ensures the ID starts with a letter (adds "id-" if necessary)
 *
 * @param {string} input
 * @returns {string} valid HTML id
 */
export function toHtmlId(input) {
  // eslint-disable-next-line no-param-reassign
  if (typeof input !== "string") input = String(input ?? "");

  // 1) Normalize Unicode and remove diacritical marks (e.g. "ä" -> "a")
  let s = input.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");

  // 2) Convert to lowercase
  s = s.toLowerCase();

  // 3) Keep only allowed characters: a-z, 0-9, '-', '_', '.'
  //    Replace everything else with '-' (multiple '-' will be merged later)
  s = s.replace(/[^a-z0-9_.-]+/g, "-");

  // 4) Collapse multiple hyphens into one, trim leading/trailing hyphens
  s = s.replace(/-{2,}/g, "-").replace(/^-+|-+$/g, "");

  // 5) ID should not start with a digit (for valid CSS selectors),
  //    prepend "id-" if it does
  if (/^[0-9]/.test(s)) s = `id-${s}`;

  // 6) If the result is empty (e.g. input had only special characters),
  //    generate a safe fallback ID
  if (!s) s = `id-${Math.random().toString(36).slice(2, 8)}`;

  return s;
}
